import React, { useEffect } from 'react';
import { FieldWrapper } from '@progress/kendo-react-form';
import { RadioGroup } from '@progress/kendo-react-inputs';
import { Label, Error, Hint } from '@progress/kendo-react-labels';
import styles from './form.module.scss';

export const RadioInput = (fieldRenderProps) => {
  const {
    validationMessage,
    touched,
    id,
    label,
    valid,
    disabled,
    hint,
    visited,
    modified,
    defaultValue,
    leftAlign,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef(null);

  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : 'options for given question';
  const errorId = showValidationMessage ? `${id}_error` : '';
  const labelId = label ? `${id}_label` : '';

  useEffect(() => {
    if (editorRef && editorRef.current && editorRef.current.element) {
      // eslint-disable-next-line prefer-const
      let radioItems = editorRef.current.element.querySelectorAll('.k-radio-item');
      radioItems.forEach((item) => {
        item.setAttribute('role', 'none');
      });
    }
  });

  return (
    <FieldWrapper>
      <Label
        for={id}
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <RadioGroup
        id={id}
        ariaDescribedBy={`${hintId}`}
        ariaLabelledBy={id}
        valid={valid}
        className={`${styles.answersGroup} ${leftAlign ? styles.leftRadio : ''}`}
        disabled={disabled}
        defaultValue={defaultValue}
        ref={editorRef}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};
